import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import State from 'types/State';
import { setMakesAndModels } from 'redux-implementations/makesAndModels';
import { fetchMakesAndModels } from 'lib/AutolistAPI';
import { MakeResponse } from 'types/MakeResponse';

export default function useMakesAndModels(): MakeResponse[] {
  const makesAndModels = useSelector((state: State) => state.makesAndModels);
  const dispatch = useDispatch();
  useEffect(() => {
    async function fetchData(): Promise<void> {
      if (!makesAndModels || makesAndModels?.length === 0) {
        const response = await fetchMakesAndModels();
        dispatch(setMakesAndModels(response));
      }
    }

    fetchData();
  }, [dispatch, makesAndModels]);

  return makesAndModels;
}
